<template>
  <div class="col-md-12 mt-2">
    <md-table
      :value="playlists"
      md-height="100%"
      md-sort="name"
      md-sort-order="asc"
      md-card
      md-fixed-header
    >
      <md-table-toolbar>
        <div class="md-toolbar-section-start">
          <h1 class="md-title">Playlists</h1>
          <!-- <router-link :to="{name: 'newClientPlayList'}">New Playlist</router-link> -->
          <b-button v-b-modal.new-playlist>New Playlist</b-button>
        </div>
      </md-table-toolbar>

      <md-table-empty-state md-label="No playlists found">
        <!-- <md-button class="md-primary md-raised" @click="newPlayList">Create new PlayList</md-button> -->
        <b-button v-b-modal.new-playlist>New Playlist</b-button>
        <!-- <router-link class="md-primary md-raised" tag="md-button" :to="{name: 'newClientPlayList'}">New PlayList</router-link> -->
      </md-table-empty-state>

      <md-table-row slot="md-table-row" slot-scope="{ item }">
        <md-table-cell md-label="ID" md-sort-by="_id">{{ item._id }}</md-table-cell>
        <md-table-cell md-label="Name" md-sort-by="name">{{ item.name }}</md-table-cell>
        <!-- <md-table-cell md-label="User" md-sort-by="user.name">{{ item.user.name }}</md-table-cell>        -->
        <md-table-cell md-label="Actions">
          <router-link
            tag="md-button"
            :to="{ name: 'editClientPlayList', params: { id: item._id } }"
            class="md-icon-button md-dense md-raised md-primary"
          >
            <md-icon><v-icon name="edit"/></md-icon>
          </router-link>
          <md-button @click="deleteItem(item)" class="md-icon-button md-dense md-raised md-accent">
            <md-icon><v-icon name="trash"/></md-icon>
          </md-button>
        </md-table-cell>
      </md-table-row>
    </md-table>

    <b-modal
      id="new-playlist"
      ref="modal"
      title="New Playlist"
      @show="resetModal"
      @hidden="resetModal"
      @ok="handleOk"
    >
      <form ref="form" @submit.stop.prevent="handleSubmit">
        <b-form-group
          :state="nameState"
          label="Name"
          label-for="name-input"
          invalid-feedback="Name is required"
        >
          <b-form-input id="name-input" v-model="name" :state="nameState" required></b-form-input>
        </b-form-group>
      </form>
    </b-modal>
  </div>
</template>

<script>
import { mapState } from "vuex";
import axios from "axios";

export default {
  data: () => ({
    search: null,
    searched: [],
    name: "",
    nameState: null
  }),
  computed: mapState({
    playlists: state => state.playlists
  }),
  mounted() {
    this.$store.dispatch("loadClientplaylists");
  },
  methods: {
    checkFormValidity() {
      const valid = this.$refs.form.checkValidity();
      this.nameState = valid;
      return valid;
    },
    resetModal() {
      this.name = "";
      this.nameState = null;
    },
    handleOk(bvModalEvt) {
      bvModalEvt.preventDefault();
      this.handleSubmit();
    },
    handleSubmit() {
      if (!this.checkFormValidity()) {
        return;
      }

      // console.log(this.name)

      const playlist = {
        name: this.name
      };

      axios
        .post(`${process.env.VUE_APP_API_URL}/api/client/playlists`, playlist)
        .then(res => {
          this.$router.push({ name: "editClientPlayList", params: { id: res.data._id } });
          // this.$nextTick(() => {
          //   this.$bvModal.hide("new-playlist");
          // });
        })
        .catch(error => {
          this.$swal.fire({
            position: "center",
            type: "error",
            title: error.response.data.message,
            showConfirmButton: true,
          });
        });
    },
    deleteItem(playlist) {
      let item = playlist;
      this.$swal
        .fire({
          title: "Are you sure?",
          text: "You won't be able to revert this!",
          type: "warning",
          showCancelButton: true,
          confirmButtonColor: "#3085d6",
          cancelButtonColor: "#d33",
          confirmButtonText: "Yes, delete it!"
        })
        .then((result) => {
          if (result.value) {
             axios.delete(`${process.env.VUE_APP_API_URL}/api/client/playlists`, { data: item }).then((res) => {
              this.$store.dispatch("loadClientplaylists");
              this.$swal.fire({
                position: "center",
                type: "success",
                title: "Playlist has been deleted.",
                showConfirmButton: false,
                timer: 1500
              });
            }).catch((error) => {
              this.$swal.fire({
                position: "center",
                type: "error",
                title: "Someting wen't worng!",
                showConfirmButton: false,
                timer: 1500
              });
            });
          }
        });
    }
  }
};
</script>
